import {required} from "vuelidate/lib/validators";  
const newstranslations = {
    data() { 
      return {   
        newstranslationsData: { 
          Title: "", 
          Description: "",  
          SeoTitle: "", 
          SeoKeywords: "", 
          SeoDescription: "", 
          Newsid: "",
          Langid: "",
          Websiteid: "", 
          Deleted: false, 
          }, 
        

          FormDataType:{
            Title:{FieldName:"Title",Field:"input",FieldTitle:this.$t('dpages.AddEdit.Title')},  
            Description:{FieldName:"Description",Field:"input",FieldTitle:this.$t('dpages.AddEdit.Description')},  
            SeoTitle:{FieldName:"SeoTitle",Field:"input",FieldTitle:this.$t('dpages.AddEdit.SeoTitle')}, 
            SeoKeywords:{FieldName:"SeoKeyword",Field:"input",FieldTitle:this.$t('dpages.AddEdit.SeoKeyword')}, 
            SeoDescription:{FieldName:"SeoDescription",Field:"input",FieldTitle:this.$t('dpages.AddEdit.SeoDescription')}, 
            Langid:{FieldName:"Dpageid",Field:"input"}, 
            Newsid:{FieldName:"Newsid",Field:"input"}, 
            Websiteid:{FieldName:"Websiteid",Field:"input"},        
          } 
      }
    },  
    validations:{ 
      FormData: {  
        Title: {required},   
        Description: {required},  
        SeoTitle: {},  
        SeoKeywords: {},   
        SeoDescription: {},  
        Langid:{required}, 
        Newsid:{required}, 
        Websiteid: {required},   


      }
 
  },
  created(){

  }
}
export default newstranslations